import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Taxpayer Name',
    dataIndex: 'taxPayerName',
    className: 'settingColumnStyle',
    sorter: true,
  },
  {
    title: 'Code',
    dataIndex: 'companyCode',
    className: 'settingColumnStyle',
    sorter: true,
  },
  {
    title: 'Division',
    dataIndex: 'divisionCode',
    className: 'settingColumnStyle',
    sorter: true,
  },
  {
    title: 'Department',
    dataIndex: 'departmentCode',
    className: 'settingColumnStyle',
    sorter: true,
  },
  {
    title: 'Partition',
    dataIndex: 'partitionName',
    className: 'settingColumnStyle',
    sorter: true,
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    width: 150,
    align: 'center',
    fixed: 'right',
    className: 'settingColumnStyle',
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
